import React, { useState } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { ComponentI } from "../../../../types";
import { renderContent } from "../../utils/renderComponent";

interface ToggleComponentProps {
  title: string;
  componentsList: ComponentI[];
  allResponses?: Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
  onChange?: (
    variable: string,
    label: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any,
    displayAs?: string,
  ) => void;
  additionalProps?: Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
  pageIndex?: number;
  inputType?: "input" | "textarea";
  value?: Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export default function ToggleComponent({
  title,
  componentsList = [],
  allResponses = {},
  onChange,
  additionalProps = {},
  pageIndex = 0,
  inputType = "input",
  value,
}: ToggleComponentProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="toggle-component px-0 sm:px-4 my-4">
      <button
        onClick={toggleExpanded}
        className="flex items-center w-full text-left font-semibold text-lg py-2 hover:text-blue-600 transition-colors"
      >
        <span
          className={`mr-2 transform transition-transform duration-200 ${
            isExpanded ? "rotate-90" : "rotate-0"
          }`}
        >
          <ChevronRightIcon className="h-5 w-5 text-blue-500" />
        </span>
        {title}
      </button>
      {isExpanded && (
        <div className="mt-2 pl-4 sm:pl-7 border-l-2 border-gray-200 space-y-4">
          {componentsList.map((component, index) =>
            renderContent({
              component,
              index,
              pageIndex,
              value,
              allResponses,
              onChange,
              additionalProps,
              inputType,
              key: `toggle_${pageIndex}_${component.type}_${index}`,
            }),
          )}
        </div>
      )}
    </div>
  );
}
